import React from "react";
import styles from "../components/laymanComp_css/LaymanPage18.module.css";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/ehyeh.json";

export default function LaymanPage18() {
  return (
    <>
   <Common_html BlockData={BlockData} />
    </>
  );
}
